import { Redirect } from "./redirect"

export function ConditionalRedirect({ when, to, replace = true, state, pending = false, fallback = null, children }) {
    if (pending) return fallback
    if (when) return <Redirect to={to} replace={replace} state={state} />
    return children
}
